import { BaseAction } from '../../store/actions';
import { VerifyApiOptions, VerifyResponse } from '../../shared/models/verify';

export enum VerifyActions {
  Verify = '[Verify] Start Verify',
  VerifySuccess = '[Verify] Verify Success',
  VerifyError = '[Verify] Verify Error',
}

export class Verify implements BaseAction<VerifyActions> {
  readonly type = VerifyActions.Verify;

  constructor(public readonly apiOptions: VerifyApiOptions, public readonly isRegistrationComplete?: boolean) {}
}

export class VerifySuccess implements BaseAction<VerifyActions> {
 readonly type = VerifyActions.VerifySuccess;

 constructor(public readonly payload: VerifyResponse) {}
}

export class VerifyError implements BaseAction<VerifyActions> {
  readonly type = VerifyActions.VerifyError;

  constructor(public readonly payload: string) {}
}

export type VerifyAction = Verify | VerifySuccess | VerifyError;
